import React, { useState,useEffect,useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { AiOutlineClose } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { get_logout } from "../../Services/Operations/ProductAPI";
import { logout } from "../../Redux/user_information";
import "../../Styles/Header.css";
import { toast } from "react-toastify";
import { FiUser } from "react-icons/fi";
import { useLocation } from "react-router-dom";

function AccountSec() {
    const dropdownRef = useRef(null);
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = useState(false); 
  const navigate = useNavigate();
  const { tokenDetails } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const token = tokenDetails;

  // window.onpopstate = () => {
  //   navigate("/auth");
  // };

  const handleLogOut = async () => {
    try {
      const result = await get_logout(token);
      if (result.success) {
        dispatch(logout());
        toast.success("Logout Successfully");

        sessionStorage.clear();
        localStorage.clear();
        navigate("/auth");
        // window.location.replace("/auth");
      }
    } catch (error) {
      console.error("Logout error:", error);
      toast.error("Logout failed");
    }
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownOpen]);

  const handleAddressesClick = () => {
    if (!token) {
      navigate("/auth", { state: { from: location.pathname } });
    } else {
      navigate("/addresses");
    }
  };

  const handleOrderClick = () => {
    if (!token) {
      navigate("/auth", { state: { from: location.pathname } });
    } else {
      navigate("/orderHistory");
    }
  };

  return (
    <div
      className="boxHover-container"
      style={{
        width: "35px",
        height: "29px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="account-menu"
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
         
        }}
        ref={dropdownRef} 
      >
        <div
          style={{
            marginLeft: "0px",
            boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            id="accountWidget"
            aria-haspopup="true"
            aria-expanded={dropdownOpen ? "true" : "false"}
            aria-label="Your account"
            title="Your account"
            style={{
              padding: "0px",
              margin: "0px",
              width: "35px",
                  height: "29px",
              backgroundColor: "transparent",
              display: "flex",
            alignItems: "center",
            justifyContent: "center",
            }}
            onClick={toggleDropdown}
          >
            {/* <FiUser /> */}
            <img src="/asset/img/people.png" style={{width:"19px"}}/>
          </button>

          {dropdownOpen && (
            <div
              className="dropdown-menu dropdown-menu-end account-menu-dropdown js-account-menu-dropdown show"
              aria-labelledby="accountWidget"
              style={{
                minWidth: "250px",
                padding: "15px",
                position: "absolute",
                top: "100%",
                right: 0,
                zIndex: 1000,
              }}
            >
              <div className="offcanvas-header">
                <button 
                  className="btn btn-light btn-block offcanvas-close js-offcanvas-close sticky-top"
                  onClick={toggleDropdown}
                >
                  <AiOutlineClose className="icon-close" />
                  Close menu
                </button>
              </div>
              <div className="offcanvas-body">
                <div className="account-menu">
                  <div className="account-menu-login">
                    {!tokenDetails ? (
                      <>
                        <a
                          title="Sign in"
                          onClick={() => {
                            navigate("/auth", {
                              state: { from: location.pathname },
                            });
                            setDropdownOpen(false);
                          }}
                          className="btn button8 btn-outline account-menu-login-button"
                        >
                          Sign in
                        </a>
                        <div className="account-menu-register">or</div>
                        <a
                          title="register"
                          onClick={() => {
                            navigate("/auth", {
                              state: { from: location.pathname },
                            });
                            setDropdownOpen(false);
                          }}
                          className="btn button8 btn-outline account-menu-login-button"
                        >
                          Register
                        </a>
                      </>
                    ) : (
                      <a
                        href=" "
                        title="My Profile"
                        onClick={() => {
                          navigate("/profile");
                          setDropdownOpen(false);
                        }}
                        className="btn button8 btn-outline account-menu-login-button"
                      >
                        My Profile
                      </a>
                    )}
                  </div>
                  <div className="account-menu-links">
                    <div className="header-account-menu">
                      <div className="card account-menu-inner">
                        <div className="list-group list-group-flush account-aside-list-group">
                          {token ? (
                            <div className="list-group-box">
                              <a
                                title="Teamshop"
                                className="list-group-item list-group-item-action account-aside-item"
                                style={{ borderWidth: 0 }}
                                onClick={() => {
                                  handleLogOut();
                                  setDropdownOpen(false);
                                }}
                              >
                                Logout
                              </a>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="list-group-box"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default AccountSec;
